import React, { useEffect } from "react";
import Post from "../components/Post"

const BlogPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Post />
        </>
    )
}

export default BlogPage;